module.exports = {
          srcSet: __webpack_public_path__ + "images/1985-4e2e57bb860e353207fee2eea15b6fd7-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/1985-eddab572e2942a46dde2cb5261ee09d8-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/1985-4e2e57bb860e353207fee2eea15b6fd7-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/1985-eddab572e2942a46dde2cb5261ee09d8-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/1985-4e2e57bb860e353207fee2eea15b6fd7-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/1985-4e2e57bb860e353207fee2eea15b6fd7-320.jpg"},
          
          width: 320,
          height: 251
        }